import { useQueryClient } from "react-query";
import { useContext, useState } from "react";
import { useUrlSearch } from "../../../../../../hooks/useUrlSearch";
import { ToastContext } from "../../../../../../hooks/context";
import { useApproveOrRejectBillsMutation } from "../../../../../../hooks/api/mutations";

export const useBillsDetails = () => {
  const queryClient = useQueryClient();
  const triggerToast = useContext(ToastContext);
  const { search, setSearch } = useUrlSearch();
  const [views, setViews] = useState({
    isAcceptDialog: false,
    isRejectDialog: false,
  });

  const { mutate: approveOrRejectBills, isLoading: isUpdatingStatus } =
    useApproveOrRejectBillsMutation();

  const handleApproveOrRejectBills = (id, status) => {
    approveOrRejectBills(
      { id, data: { status } },
      {
        onSuccess: () => {
          const message =
            status === "APPROVED"
              ? "Bill Approval Successful"
              : "Bill Rejection Successful";
          triggerToast(message, "success");
          queryClient.invalidateQueries(["getBillsDetails", `${id}`]);
          setViews({
            isAcceptDialog: false,
            isRejectDialog: false,
          });

          if (status === "APPROVED") {
            search.set("new_approved_gr_id", id);
            setSearch(search, { replace: true });
          }
        },
      },
    );
  };

  return {
    isUpdatingStatus,
    views,
    search,
    setViews,
    handleApproveOrRejectBills,
  };
};
